import API from "../../../store/api";
import { getAllUsers } from './getAllUsers';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearUsers } from '../../../store/actions/usersActions';
import { authLogout } from '../../../store/actions/authActions';

export const updateUser = (id, userData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.put(`/api/portal/users/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(userData)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllUsers(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          formFunction();
        } else if (response.status === 401) {
          dispatch(clearUsers);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
            if (message.includes(',')) { //Password error, make it more presentable
              let messageArray = message.split(',');
              message = <>{messageArray.map((val) => <div>{val}</div>)}</>
            }
          }
        }
        dispatch(setMessage({
          title: 'Update User Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}